import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat, SBDate } from '../date-time/sb-date-time';

@Pipe({
    name: 'formatDate'
})
export class LocalizationDatePipe implements PipeTransform {

    transform(value: string | null, pattern: DateFormat) : string {
        if (!value) {
            return '';
        }

        try {
            return SBDate.FromISO(value!).Render(pattern);
        } catch {
            return '';
        }
    }
}
